import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { IUser } from 'typings/doenkids/doenkids';

/**
 * The per-user AI feature flag.
 *
 * Write only: `ai_enabled` is readable straight off the fetched user, but it is
 * deliberately absent from the generic user update's property whitelist, so it
 * cannot be SET through a normal user save and this route is the only way to
 * change it. DoenKids administrators only, so gate the UI on
 * `DoenkidsSessionProvider.isAdmin$`.
 */
@Injectable({
  providedIn: 'root',
})
export class UserAiEnabledService {
  constructor(private $baseApi: DoenKidsGenericApiProvider) {}

  /** Sets the flag and returns the updated user. */
  async update(userId: number, aiEnabled: boolean) {
    return (await firstValueFrom(
      this.$baseApi.genericPutCall(`/customer/user/${userId}/ai-enabled`, { ai_enabled: aiEnabled }),
    )) as IUser;
  }
}
